export default {
    // HOST: 'http://47.123.7.42:8080',
    // HOST: 'http://127.0.0.1:8000',
    // BASE_URL: 'http://47.123.7.42:8081/api/v1/',
    // BASE_URL: 'http://127.0.0.1:8001/api/'
    BASE_URL: 'https://dreamportal.nextscene.cn/api/'

}